const returnDeposit = (() => {
	// basic controls to prevent runaway recursion
	let requestCount = 0,
		requestCountLimit = 50,
		requestsEnabled = true;

	// prevent reconciliation tasks running simultaneously
	let cartReconciliationInProgress = false;

	const addListeners = () => {
		['SCE:add', 'SCE:update', 'SCE:change'].forEach((customEvent) => {
			window.addEventListener(customEvent, (event) => {
				inspectCartItems(customEvent);
			});
		});

		document.addEventListener('DOMContentLoaded', () => {
			inspectCartItems('DOMContentLoaded');
		});
	};

	const debugMessage = (m) => {
		// console.debug(m);
	};

	const resetRequestCount = () => {
		debugMessage('Cart api requests are allowed again');
		requestCount = 0;
		requestsEnabled = true;
		cartReconciliationInProgress = false;
	};

	// try to reconcile cart (add or remove surcharge items)
	const reconcileCartItems = async (cartData, trigger) => {
		debugMessage('---');
		debugMessage('Starting new reconciliation run - ' + trigger);
		// TODO: improve this failsafe. rather than stopping. use some sort of backing off time interval
		if (requestsEnabled) {
			requestCount++;
			if (requestCount >= requestCountLimit) {
				requestsEnabled = false;
				console.error('Too many cart api requests. Cooling off for 10 seconds');
				setTimeout(resetRequestCount(), 10000);
				return;
			}
		}

		if (!cartData || !cartData.items) return;

		let lookups = [];

		[...cartData.items].forEach((lineItem) => {
			lookups.push(lineItem.handle);
		});

		cartReconciliationInProgress = true;

		await fetch(window.routes.sample_product_url + '?view=surcharge-metafields&handles=' + lookups.join(','))
			.then((response) => response.json())
			.then((surchargeItems) => {
				let changesmade = 0;

				if (surchargeItems) {
					changesmade = checkCartItems(cartData, surchargeItems);
				}

				if (changesmade === 0) {
					cleanupCart(cartData);
				}
			})
			.finally(() => {
				cartReconciliationInProgress = false;
			});
	};

	const checkCartItems = (cartData, surchargeItems) => {
		let changesmade = 0;
		let requiredSurchargeItems = [];
		let okToContinue = true;
		let addToCartPayload = {items: []};

		[...cartData.items].forEach((lineItem) => {
			let lineCounter = 0;
			[...surchargeItems].forEach((surchargeItem) => {
				if (surchargeItem[lineItem.handle]) {

					debugMessage('Found line item that requires a surcharge item');

					// check if item has the required _surcharge property,
					if (
						lineItem.properties &&
						lineItem.properties['_surcharge'] &&
						lineItem.properties['_surcharge'].toString() === surchargeItem[lineItem.handle].toString()
					) {

						debugMessage('Line item already has correct property set');

						requiredSurchargeItems.push({
							item: surchargeItem[lineItem.handle],
							quantity: lineItem.quantity,
							source: lineItem.key
						});

					} else {
						debugMessage('Line item needs correct property set');

						// add the missing _surcharge property
						changesmade++;

						let currentProperties = lineItem.properties;
						currentProperties['_surcharge'] = surchargeItem[lineItem.handle].toString();

						const payload = {
							id: lineItem.key,
							quantity: lineItem.quantity,
							properties: currentProperties,
						};

						debugMessage('Sending property changes ... ');
						okToContinue = false;
						updateCart(payload);
					}
				}
			});
			lineCounter++;
		});

		if (okToContinue) {
			[...requiredSurchargeItems].forEach(requiredSurchargeItem => {
				const currentlyInCart = findCartItemWithMatchingSource(
					cartData,
					requiredSurchargeItem.item,
					requiredSurchargeItem.source
				);

				if (!currentlyInCart) {
					debugMessage('Matching surcharge item not in cart');
					// add surcharge item to cart
					changesmade++;
					addToCartPayload.items.push({
						id: requiredSurchargeItem.item,
						quantity: requiredSurchargeItem.quantity,
						properties: {'_surcharge-for': requiredSurchargeItem.source},
					});
				} else if (currentlyInCart.quantity !== requiredSurchargeItem.quantity) {
					debugMessage('Matching surcharge item in cart but quantity does not match');
					// update surcharge item quantity in cart
					changesmade++;
					let currentProperties = currentlyInCart.properties;
					currentProperties['_surcharge-for'] = requiredSurchargeItem.source;
					const payload = {
						id: currentlyInCart.key,
						quantity: requiredSurchargeItem.quantity,
						properties: currentProperties,
					};

					debugMessage('Sending cart updates ... ');
					updateCart(payload);
				} else {
					debugMessage('Matching surcharge item was found in cart');
				}
			});

			if (addToCartPayload.items.length) {
				debugMessage('Sending cart additions ... ');
				addCart(addToCartPayload);
			}
		}

		return changesmade;
	};

	const cleanupCart = (cartData) => {
		// check cart for any un-matched surcharge items

		debugMessage('Searching for unmatched cart surcharge items');
		// all items with a _surcharge-for property should have a matching item in cart 
		// _surcharge-for value should match the line item key of the corresponding cart item
		[...cartData.items].forEach((lineItem) => {
			if (lineItem.properties['_surcharge-for']) {
				const currentlyInCart = findCartItemWithMatchingKey(cartData, lineItem.properties['_surcharge-for']);

				if (!currentlyInCart) {
					// remove item from cart
					const payload = {
						id: lineItem.key,
						quantity: 0,
					};

					debugMessage('Removing unnecessary surcharge items ... ');
					updateCart(payload);
				}
			}
		});

		// finally using global variable containing list of all surcharge products 
		// check if any surcharge items are in cart but should not be
		// compare surcharge item _surcharge-for property against lineitem key of each cart item
		debugMessage('Searching for orphaned cart surcharge items');
		[...allSurchargeItems].forEach((surchargeItem) => {
			const currentlyInCart = findCartItem(cartData, surchargeItem.id);

			if (currentlyInCart) {
				const requiredInCart = requiredSurchargeItemsCount(cartData, currentlyInCart);

				if (requiredInCart === 0) {
					// remove item from cart
					const payload = {
						id: surchargeItem.key,
						quantity: 0,
					};

					debugMessage('Removing orphaned surcharge items ... ');
					updateCart(payload);
				}
			}
		});
	};

	const findCartItem = (cart, item) => {
		for (cartItem of cart.items) {
			if (cartItem.variant_id === item) {
				return cartItem;
			}
		}
	};

	const findCartItemWithMatchingSource = (cart, item, source) => {
		for (cartItem of cart.items) {
			if (cartItem.variant_id === item && cartItem.properties['_surcharge-for'] === source) {
				return cartItem;
			}
		}
	};

	const findCartItemWithMatchingKey = (cart, key) => {
		for (cartItem of cart.items) {
			if (cartItem.key === key) {
				return cartItem;
			}
		}
	};

	const requiredSurchargeItemsCount = (cart, surchargeItem) => {
		let retval = 0;

		for (cartItem of cart.items) {
			if (cartItem.properties['_surcharge'] == surchargeItem.id && cartItem.key == surchargeItem.properties['_surcharge-for']) {
				retval += cartItem.quantity;
			}
		}

		return retval;
	};

	const updateCart = async (details) => {
		// TODO: improve this failsafe. rather than stopping. use some sort of backing off time interval
		if (requestsEnabled) {
			requestCount++;
			if (requestCount >= requestCountLimit) {
				requestsEnabled = false;
				console.error('Too many cart api requests. Cooling off for 10 seconds');
				setTimeout(resetRequestCount(), 10000);
				return;
			}
		}

		cartReconciliationInProgress = true;

		await fetch(window.routes.cart_change_url + '.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: new Headers({
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
				// 'Accept:': 'application/json',
			}),
			body: JSON.stringify(details),
		})
			.then((response) => response.json())
			.then((response) => {
				// TODO: display any errors

				refreshCart();
				refreshBanner(response);
			})
			.catch((e) => {
				console.error(e);
			})
			.finally(() => {
				cartReconciliationInProgress = false;
			});
	};

	const addCart = async (details) => {
		// TODO: improve this failsafe. rather than stopping. use some sort of backing off time interval
		if (requestsEnabled) {
			requestCount++;
			if (requestCount >= requestCountLimit) {
				requestsEnabled = false;
				console.error('Too many cart api requests. Cooling off for 10 seconds');
				setTimeout(resetRequestCount(), 10000);
				return;
			}
		}
		
		cartReconciliationInProgress = true;

		await fetch(window.routes.cart_add_url + '.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: new Headers({
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
				// 'Accept:': 'application/json',
			}),
			body: JSON.stringify(details),
		})
			.then((response) => response.json())
			.then((response) => {
				// TODO: display any errors

				refreshCart();
				refreshBanner(response);
			})
			.catch((e) => {
				console.error(e);
			})
			.finally(() => {
				cartReconciliationInProgress = false;
			});
	};

	const refreshBanner = (cartData) => {
		debugMessage('Refreshing banner(s) status ...');
		let surchargeItems = 0;
		if (cartData && cartData.items) {
			[...cartData.items].forEach((item) => {
				if (item.properties['_surcharge']) {
					surchargeItems++;
				}
				if (item.properties['_surcharge-for']) {
					surchargeItems++;
				}
			});
			if (surchargeItems > 0) {
				[...document.querySelectorAll('[data-deposit-surcharge-banner="true"]')].forEach((banner) => {
					banner.classList.add('active');
				});
			} else {
				[...document.querySelectorAll('[data-deposit-surcharge-banner="true"]')].forEach((banner) => {
					banner.classList.remove('active');
				});
			}
		}
	};

	const inspectCartItems = async (trigger) => {
		if (cartReconciliationInProgress) {
			debugMessage('reconciliation run already in progress. skipping ... ');
			return;
		}

		await fetch(window.routes.cart_url + '.js')
			.then((response) => response.json())
			.then((cart) => {
				// TODO: display any errors

				reconcileCartItems(cart, trigger);
			})
			.catch((e) => {
				console.error(e);
			});
	};

	// copied from theme.js with minor modifications
	let cartRefreshXhr;
	const refreshCartDependentContent = () => {
		const thisContainer = $('div.container.fully-spaced-row');
        if (cartRefreshXhr) {
          cartRefreshXhr.abort();
        }
        // fetch new html for the page
        cartRefreshXhr = $.ajax({
          type: 'GET',
          url: theme.routes.cart_url,
          success: function (data) {
            var toReplace = ['.cart-item-list', '.checkout-subtotal-container__dynamic'];
            var $newDom = $('<div>' + data + '</div>');

            // remove any transitions
            $newDom.find('.fade-in').removeClass('fade-in');
            $newDom.find('[data-cc-animate]').removeAttr('data-cc-animate');

            for (var i = 0; i < toReplace.length; i++) {
              this.replacingContent = true; // to avoid triggering change events when focus is lifted before DOM replacement
              var $toReplace = thisContainer.find(toReplace[i]),
              $replaceWith = $newDom.find(toReplace[i]);
              // preserve loaded images
              $replaceWith.find('.cart-item__image').each(function () {
                var $match = $toReplace.find('#' + this.id);
                if ($match.length) {
                  $(this).replaceWith($match.clone());
                }
              });
              $toReplace.replaceWith($replaceWith);
              this.replacingContent = false;
            }
          },
          error: function error(data) {
            if (data.statusText != 'abort') {
              console.error('Error refreshing page');
              console.error(data);
            }
          },
          complete: function () {
            this.cartRefreshXhr = null;
          }
		});
	};
	  
	// TODO: figure this out for each theme we use
	const refreshCart = (state) => {
		debugMessage('Refreshing mini-cart and counter ...');
		// TODO: these sections are for Be Yours only
		// const sections = ['#mini-cart', '#cart-icon-bubble', '#mobile-cart-icon-bubble'];
		let sections = [];

		const cartPageSection = document.querySelector('.section-main-cart');
		if (cartPageSection !== null) {
			sections = ['#' + cartPageSection.id];
		}

		let validSectionParams = [];
		[...sections].forEach((testSection) => {
			if (document.querySelector(testSection) !== null) {
				validSectionParams.push(testSection.replace('#', '').replace('shopify-section-', ''));
			}
		});

		if (validSectionParams) {
			let sectionRenderer = window.location.pathname + '?sections=' + validSectionParams.join(',');
			fetch(sectionRenderer)
				.then((response) => response.json())
				.then((responseJson) => {
					[...sections].forEach((sectionId) => {
						const section = document.querySelector(sectionId);
						if (section !== null) {

							debugMessage('Refreshing cart page ...');

							// theme.CartTemplateSection.functions.refreshCartDependentContent();
							refreshCartDependentContent();

							// const retrievedSectionId = sectionId.replace('#', '').replace('shopify-section-', '');
							// let newMarkup = responseJson[retrievedSectionId];
							// newMarkup = newMarkup.replace(/data-cc-animate/g, '');
							// section.innerHTML = newMarkup;
							
							// let markup = responseJson[retrievedSectionId];
							// let stringified = JSON.stringify(markup);
							// stringified = stringified.replace(/data-cc-animate/g, '');
							// markup = JSON.parse(stringified);
							// let temp = document.createElement('template');
							// markup = markup.trim();
							// temp.innerHTML = markup;
							// let html = temp.content.firstChild;
							// section.replaceWith(html);
							// theme.initAnimateOnScroll();
						}
					});
				})
				.catch((e) => {
					console.error(e);
				});
		}

		

		// none of the above worked on Flex theme mini-cart / cart counter as it does not have any of these setup as sections 
		// copied from cart-drawer.js
		$.ajax({
			type: 'GET',
			url: '/cart.js',
			dataType: 'json',
			success: function (cart) {
				onCartUpdate(cart);

				if (cart.item_count === 0) {
					cartDrawerContent.innerHTML =
						'<p class="empty-cart-state">Your cart is empty <span class="js-ajax-cart-continue-shopping">Continue shopping</span></p>';
					if (document.querySelector('.js-ajax-cart-continue-shopping')) {
						document.querySelector('.js-ajax-cart-continue-shopping').addEventListener('click', function () {
							closeAddModal();
							closeCartOverlay();
						});
					}
				} else {
					if (cartCounter) {
						cartCounter.innerHTML = cart.item_count;
					}
					renderCart(cart);
				}
			},
		});
	};

	// copied from cart-drawer.js
	const defaults = {
		cartModal: '.js-ajax-cart-modal', // classname
		cartModalContent: '.js-ajax-cart-modal-content', // classname
		cartModalClose: '.js-ajax-cart-modal-close', // classname
		cartDrawer: '.js-ajax-cart-drawer', // classname
		cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
		cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
		cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
		cartOverlay: '.js-ajax-cart-overlay', // classname
		cartCounter: '.js-ajax-cart-counter', // classname
		addToCart: '.js-ajax-add-to-cart', // classname
		increaseCart: '.custom-quantity-up', //classname
		decreaseCart: '.custom-quantity-down', //classname
		removeFromCart: '.ajax-cart-item__remove', //classname
		removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
		checkoutButton: '.js-ajax-checkout-button',
	};

	// copied from cart-drawer.js
	const cartModal = document.querySelector(defaults.cartModal);
	const cartModalContent = document.querySelector(defaults.cartModalContent);
	const cartCounter = document.querySelector(defaults.cartCounter);
	const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
	let increaseCart = document.querySelectorAll(defaults.increaseCart);
	let decreaseCart = document.querySelectorAll(defaults.decreaseCart);
	let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
	const htmlSelector = document.documentElement;

	// copied from cart-drawer.js
	function addToCartFail(jqXHR, textStatus, errorThrown) {
		// if (!errorThrown) {
		// 	errorThrown = 'An unknown error occurred. Please wait a few seconds and try again.';
		// }
		cartModalContent.innerHTML = errorThrown;
		openAddModal();
		openCartOverlay();
		setTimeout(function () {
			cartModalContent.innerHTML = '';
		}, 3000);
	}

	// copied from cart-drawer.js
	function onCartUpdate(cart) {
		document.querySelector('.cart-summary-overlay__subtotal-amount.theme-money').innerHTML =
			'€' + Shopify.formatMoney(cart.total_price, '{{amount}}');
	}

	// copied from cart-drawer.js
	function openAddModal() {
		cartModal.classList.remove('cart-summary-overlay--off-screen');
	}

	// copied from cart-drawer.js
	function closeAddModal() {
		cartModal.classList.add('cart-summary-overlay--off-screen');
	}

	// copied from cart-drawer.js
	function openCartOverlay() {
		document.querySelector('#shopify-section-cart-drawer').classList.add('actived');
		htmlSelector.classList.add('is-locked');
	}

	// copied from cart-drawer.js
	function closeCartOverlay() {
		document.querySelector('#shopify-section-cart-drawer').classList.remove('actived');
		htmlSelector.classList.remove('is-locked');
	}

	// copied from cart-drawer.js
	function clearCartDrawer() {
		cartDrawerContent.innerHTML = '';
	}

	// copied from cart-drawer.js
	function renderCart(cart) {
		clearCartDrawer();

		if (cart.item_count > 0) {
			document.querySelector('.cart-link__count').innerHTML = cart.item_count;
			document.querySelector('.cart-link__count').classList.remove('hidden');
		} else {
			document.querySelector('.cart-link__count').classList.add('hidden');
		}

		cart.items.forEach(function (item, index) {
			if (item.properties && item.properties['_hidden']) return false;
			let productBundleClass = '';
			let productURL = item.url;
			if (item.properties && item.properties['_box-product1']) {
				productBundleClass = 'ajax-cart-item__bundle';
			}

			if (item.properties && item.properties['_core-product-url']) {
				productURL = item.properties['_core-product-url'];
			}
			const productTitle = () => {
				if (item.properties && item.properties['_surcharge-for']) {
					return '<div class="ajax-cart-item__title cart-summary-overlay__title">' + item.title + '</div>';
				}
				return (
					'<a href="' +
					productURL +
					'" class="ajax-cart-item__title cart-summary-overlay__title">' +
					item.title +
					'</a>'
				);
			};
			let productProperties = '';
			if (item.properties) {
				let properties_html = '';
				productProperties =
					'<div class="ajax-cart-item__properties cart-summary-overlay__properties">{{properties}}</div>';
				for (const property in item.properties) {
					if (property.includes('box-product')) {
						properties_html += '<div class="line-item-property">' + item.properties[property].split(':')[1] + '</div>';
					}
				}
				productProperties = productProperties.replace('{{properties}}', properties_html);
			}

			let min_quantity = 0;
			if (item.properties && item.properties['_min_order_quantity']) {
				min_quantity = item.properties['_min_order_quantity'];
			}

			const productImage =
				'<div class="ajax-cart-item__image cart-summary-overlay__column-image"><img src="' + item.image + '" ></div>';
			const productPrice =
				'<div class="cart-summary-overlay__column-price">€' +
				Shopify.formatMoney(item.line_price, '{{amount}}') +
				'</div>';
				const productQuantity = () => {
					return '<div class="ajax-cart-item__quantity" min="' + min_quantity + '">' + item.quantity + '</div>';
				};
				const productRemove = () => {
					if (item.properties && item.properties['_surcharge-for']) {
						return '';
					}
					return (
						'<a class="ajax-cart-item__remove remove' +
						defaults.removeFromCartNoDot +
						'" data-id="' +
						item.key +
						'"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4995 4.34912L2.49951 4.34913" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.5 7.34912V11.3491" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 7.34912V11.3491" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.5 4.34912V13.8491C12.5 13.9817 12.4473 14.1089 12.3536 14.2027C12.2598 14.2964 12.1326 14.3491 12 14.3491H4C3.86739 14.3491 3.74021 14.2964 3.64645 14.2027C3.55268 14.1089 3.5 13.9817 3.5 13.8491V4.34912" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.5 4.34912V3.34912C10.5 3.0839 10.3946 2.82955 10.2071 2.64201C10.0196 2.45448 9.76522 2.34912 9.5 2.34912H6.5C6.23478 2.34912 5.98043 2.45448 5.79289 2.64201C5.60536 2.82955 5.5 3.0839 5.5 3.34912V4.34912" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>'
					);
				};
				const getQuantityMarkup = () => {
					if (item.properties && item.properties['_surcharge-for']) {
						return (
							'<div class="cart-summary-overlay__column-quantity"><div class="cart-item__column cart-item__quantity" style="text-align: left">Quantity: ' +
							item.quantity +
							'</div></div>'
						);
					}

					return (
						'<div class="cart-summary-overlay__column-quantity"><div class="cart-item__column cart-item__quantity"><div class="quantity buttoned-input">' +
						'<a data-id="' +
						item.key +
						'" class="notabutton custom-quantity-down" data-sign="-"><svg width="9" height="4" viewBox="0 0 9 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.356045 3.128V0.632H8.49205V3.128H0.356045Z" fill="#040202"></path></svg></a>' +
						productQuantity() +
						'<a data-id="' +
						item.key +
						'" class="notabutton custom-quantity-up" data-handle="' +
						item.handle +
						'" data-quantity="' +
						item.quantity +
						'" data-sign="+"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.919816 7.16V4.76H11.5038V7.16H0.919816ZM4.99982 0.415999H7.44782V11.48H4.99982V0.415999Z" fill="#040202"></path></svg></a>' + 
						'</div></div></div>'
					);
				};
			const concatProductInfo =
				'<div class="ajax-cart-item__single cart-summary-overlay__row-body ' +
				productBundleClass +
				'" data-line="' +
				Number(index + 1) +
				'">' +
				productImage +
				'<div class="cart-summary-overlay__column-item">' +
				productTitle() +
				productProperties +
				productRemove() +
				productPrice +
				getQuantityMarkup() +
				'</div>' +
				'</div><form data-product-id="' +
				item.id +
				'"></form>';

			cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
		});

		increaseCart = document.querySelectorAll(defaults.increaseCart);
		for (let i = 0; i < increaseCart.length; i++) {
			increaseCart[i].addEventListener('click', function () {
				if (!this.classList.contains('disable')) {
					addOneItem(this);
				}
			});
		}

		decreaseCart = document.querySelectorAll(defaults.decreaseCart);
		for (let i = 0; i < decreaseCart.length; i++) {
			decreaseCart[i].addEventListener('click', function () {
				removeOneItem(this);
			});
		}

		removeFromCart = document.querySelectorAll(defaults.removeFromCart);
		for (let i = 0; i < removeFromCart.length; i++) {
			removeFromCart[i].addEventListener('click', function () {
				removeFromCartDrawer(this, cart, i);
			});
		}
	}

	// copied from cart-drawer.js
	function addOneItem(callback) {
		let quantity = parseInt(callback.closest('.quantity').querySelector('.ajax-cart-item__quantity').innerHTML);
		const variantId = callback.getAttribute('data-id');
		let final_quantity = quantity + 1;
		let self = callback;
		self.classList.add('disable');

		$.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data: {id: variantId, quantity: final_quantity},
			dataType: 'json',
			success: function (cart) {
				if (typeof callback === 'function') {
					callback(cart);
				} else {
					fetchCart();
					openAddModal();
					openCartOverlay();
				}
			},
			error: addToCartFail,
		});
	}

	// copied from cart-drawer.js
	function removeOneItem(callback) {
		const quantity = callback.closest('.quantity').querySelector('.ajax-cart-item__quantity').innerHTML;
		const id = callback.getAttribute('data-id');
		const min_quantity = parseInt(
			callback.closest('.quantity').querySelector('.ajax-cart-item__quantity').getAttribute('min')
		);
		const sign = callback.getAttribute('data-sign');
		let final_quantity = quantity - 1;

		if (final_quantity < min_quantity) return false;

		$.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data: 'quantity=' + final_quantity + '&id=' + id,
			dataType: 'json',
			success: function (cart) {
				if (typeof callback === 'function') {
					callback(cart);
				} else {
					quantArray = [];
					fetchCart();
					removeProductFromCart();
					openAddModal();
					openCartOverlay();
				}
			},
		});
	}

	// copied from cart-drawer.js
	function removeProductFromCart() {
		if (cartCounter) {
			cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
		}
	}

	// copied from cart-drawer.js
	function fetchCart() {
		$.ajax({
			type: 'GET',
			url: '/cart.js',
			dataType: 'json',
			success: function (cart) {
				onCartUpdate(cart);

				if (cart.item_count === 0) {
					cartDrawerContent.innerHTML =
						'<p class="empty-cart-state">Your cart is empty <span class="js-ajax-cart-continue-shopping">Continue shopping</span></p>';
					if (document.querySelector('.js-ajax-cart-continue-shopping')) {
						document.querySelector('.js-ajax-cart-continue-shopping').addEventListener('click', function () {
							closeAddModal();
							closeCartOverlay();
						});
					}
				} else {
					if (cartCounter) {
						cartCounter.innerHTML = cart.item_count;
					}
					renderCart(cart);
				}
			},
		});
	}

	// copied from cart-drawer.js
	const removeFromCartDrawer = (e, cart, index) => {
		let variantId = e.getAttribute('data-id');
		let requestData = {updates: {}};
		requestData.updates[variantId] = 0;
		let cartItem = cart.items[index];
		let cartProperties = cartItem.properties;

		let cartKeys = {};

		for (const key in cart.items) {
			let productID = cart.items[key].id;
			cartKeys[productID] = {
				cart_key: cart.items[key].key,
				product_quantity: cart.items[key].quantity,
			};
		}

		for (const key in cartProperties) {
			if (key.includes('_box-product')) {
				let itemId = cartProperties[key].split(':')[0];
				if (requestData.updates[cartKeys[itemId].cart_key]) {
					requestData.updates[cartKeys[itemId].cart_key] = requestData.updates[cartKeys[itemId].cart_key] - 1;
				} else {
					requestData.updates[cartKeys[itemId].cart_key] = cartKeys[itemId].product_quantity - 1;
				}
			}
		}

		fetch('/cart/update.js', {
			body: JSON.stringify(requestData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */,
			},
			method: 'POST',
		})
			.then(function (response) {
				return response.json();
			})
			.then(function (json) {
				/* we have JSON */
				let totalPrice = json.total_price;
				let totalPriceFormat = Shopify.formatMoney(totalPrice, '{{amount}}');
				e.closest('.cart-summary-overlay__row-body').remove();
				document.querySelector('.cart-summary-overlay__subtotal-amount.theme-money').innerHTML = totalPriceFormat;
				if (json.item_count > 0) {
					document.querySelector('.cart-link__count').innerHTML = json.item_count;
					document.querySelector('.cart-link__count').classList.remove('hidden');
				}
				if (json.item_count == 0) {
					const emptyMessage =
						'<p class="empty-cart-state">Your cart is empty <span class="js-ajax-cart-continue-shopping">Continue shopping</span></p>';
					document.querySelector('.cart-summary-overlay__items').innerHTML = emptyMessage;
					document.querySelector('.cart-link__count').classList.add('hidden');
				}
				quantArray = [];
				openAddModal();
				openCartOverlay();
				if (document.querySelector('.js-ajax-cart-continue-shopping')) {
					document.querySelector('.js-ajax-cart-continue-shopping').addEventListener('click', function () {
						closeAddModal();
						closeCartOverlay();
					});
				}
			})
			.catch(function (err) {
				/* uh oh, we have error. */
				console.error(err);
			});
	};

	return {
		init: () => {
			debugMessage('returnDeposit script has loaded');
			addListeners();
		},
	};
})();

// export default returnDeposit;
returnDeposit.init();
